import { Component } from '@angular/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs/Subscription';
import { fuseAnimations } from '../../../../../../../../../../../../../core/animations';

import { SideNavService } from '../../../../../../../sidenav.service';

import { spekwo, userInfo } from '../../../../../../../../../../utils/index';

@Component({
    selector: 'questionaire',
    templateUrl: './questionaire.component.html',
    styleUrls: ['./questionaire.component.scss'],
    animations: fuseAnimations
})

export class QuestionaireComponent {

    spekwoValues = spekwo;
    userInfo = userInfo;

    storedStories = [];
    collegePicTimes = [];
    numberOfTimes = [
        {
            section: 1,
            first: '',
            second: '',
            third: '',
            disable: false,
            cardExpanded: true
        },
        {
            section: 2,
            first: '',
            second: '',
            third: '',
            disable: false,
            cardExpanded: true
        }, {
            section: 3,
            first: '',
            second: '',
            third: '',
            disable: false,
            cardExpanded: true
        }, {
            section: 4,
            first: '',
            second: '',
            third: '',
            disable: false,
            cardExpanded: true
        }, {
            section: 5,
            first: '',
            second: '',
            third: '',
            disable: false,
            cardExpanded: true
        },
    ];

    userId: string = "";

    loadAllImage = 0;

    isImgLoading: boolean = false;

    onProUserInfoTabSelectedSubscription: Subscription;

    constructor(
        public sideNavService: SideNavService
    ) {

    }

    ngOnInit() {


        this.onProUserInfoTabSelectedSubscription =
            this.sideNavService.onProUserInfoTabSelected.subscribe(selected => {

                this.userId = selected.userId;

                this.getAllStories();

                /** Initially load all images*/
                this.collegePicTimes = [
                    {
                        column: 1,
                        section: 1,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '1_1.png',
                    }, {
                        column: 2,
                        section: 1,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '1_2.png'
                    }, {
                        column: 3,
                        section: 1,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '1_3.png'
                    }, {
                        column: 4,
                        section: 1,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '1_4.png'
                    },
                    {
                        column: 1,
                        section: 2,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '2_1.png'
                    }, {
                        column: 2,
                        section: 2,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '2_2.png'
                    }, {
                        column: 3,
                        section: 2,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '2_3.png'
                    }, {
                        column: 4,
                        section: 2,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '2_4.png'
                    },
                    {
                        column: 1,
                        section: 3,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '3_1.png'
                    }, {
                        column: 2,
                        section: 3,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '3_2.png'
                    }, {
                        column: 3,
                        section: 3,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '3_3.png'
                    }, {
                        column: 4,
                        section: 3,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '3_4.png'
                    },
                    {
                        column: 1,
                        section: 4,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '4_1.png'
                    }, {
                        column: 2,
                        section: 4,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '4_2.png'
                    }, {
                        column: 3,
                        section: 4,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '4_3.png'
                    }, {
                        column: 4,
                        section: 4,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '4_4.png'
                    },
                    {
                        column: 1,
                        section: 5,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '5_1.png'
                    }, {
                        column: 2,
                        section: 5,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '5_2.png',
                    }, {
                        column: 3,
                        section: 5,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '5_3.png',
                    }, {
                        column: 4,
                        section: 5,
                        src: this.spekwoValues.picStories + '/' + this.userId + '/' + '5_4.png',
                    }
                ];
            });


    }

    ngOnDestroy() {

        this.onProUserInfoTabSelectedSubscription.unsubscribe();
    }

    /**Get all pic stories */
    getAllStories() {

        this.storedStories = [];

        this.sideNavService.fetchPicStories(this.userId)
            .then((response: any) => {
                if (response &&
                    response.data.allPicStories &&
                    response.data.allPicStories.nodes) {

                    this.storedStories = this.storedStories.concat(response.data.allPicStories.nodes);

                    if (response.data.allPicStories.nodes.length == this.storedStories.length) {
                        this.assignStoredStories();
                    }

                }
            })
            .catch(err => {
                console.log('err', err);
            })
    }

    // Assigned stored result from database
    assignStoredStories() {

        _.each(this.numberOfTimes, (single, index) => {

            if (this.storedStories.length > 0) {
                var result = _.find(this.storedStories, { section: single.section });

                if (result) {
                    this.numberOfTimes[index].first = result.descFirst;
                    this.numberOfTimes[index].second = result.descSecond;
                    this.numberOfTimes[index].third = result.descThird;
                    this.numberOfTimes[index].disable = true;

                }
            }
            else {
                this.numberOfTimes[index].first = '';
                this.numberOfTimes[index].second = '';
                this.numberOfTimes[index].third = '';
                this.numberOfTimes[index].disable = false;
            }

            if (index + 1 == this.numberOfTimes.length) {
                this.numberOfTimes = this.numberOfTimes;
            }
        })

    }

    /**Get each img dynamically & display */
    getSrc(section, column) {

        var result = _.find(this.collegePicTimes, { 'section': section + 1, 'column': column });
        return result ? result.src : this.spekwoValues.defaultStory;
    }

    /**Story pic error handler */
    errorHandler(event) {
        event.target.src = this.spekwoValues.defaultStory;
    }

    loadImage() {

        ++this.loadAllImage;

        if (this.loadAllImage == this.collegePicTimes.length) {

            this.isImgLoading = false;
            this.loadAllImage = 0;
        }

    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/user-info/details/tabs/credibility-center/questionaire/questionaire.component.ts